import { Brand, createBranded } from '@deltasierra/type-utilities';

export type BannerNotificationId = Brand<number, 'BannerNotificationId'>;
export const BannerNotificationId = createBranded<BannerNotificationId>();
